import Vue from "vue";
import Antd from "ant-design-vue";
import App from "./App.vue";
import "ant-design-vue/dist/antd.css";
import router from "./router";
import store from "./store/store";
import "./assets/css/global.css";
import VModal from "vue-js-modal";
import "vue2-animate/dist/vue2-animate.min.css";
import VuePrlx from "vue-prlx";
import VueNumericInput from "vue-numeric-input";
import vco from "v-click-outside";
import VueMq from "vue-mq";
import VueAgile from "vue-agile";
import AOS from "aos";
import "aos/dist/aos.css";
import VueDragscroll from "vue-dragscroll";
import Vuelidate from "vuelidate";
import moment from "moment";
import VueScrollTo from "vue-scrollto";
import "animate.css";
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import ProductCardNotificationLine from './components/cards/ProductCardNotificationLine'
import OpeningTimeNotificationCard from './components/cards/OpeningTimeNotificationCard'
import vueMq from "vue-mq";
import VueLoading from 'vuejs-loading-plugin'
import MultiSelect from 'vue-multiselect'
Vue.component('multiselect', MultiSelect)
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueMeta from 'vue-meta'
import VueIframe from 'vue-iframes';
Vue.use(VueIframe);

Vue.use(VueMeta)

Vue.config.productionTip = false;
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    ipadpro: 1025,
    laptop: 1250,
    desktop: Infinity
  }
});
Vue.use(vco);
Vue.use(VueNumericInput);
Vue.use(Antd);
Vue.use(VueSlickCarousel)
Vue.use(VModal);

Vue.use(VuePrlx);
Vue.use(VueAgile);
Vue.use(VueDragscroll);
Vue.use(Vuelidate);
Vue.use(VueScrollTo);
Vue.use(VueLoading);
Vue.component('product-card-notification-line', ProductCardNotificationLine);
Vue.component('opening-time-notification-card', OpeningTimeNotificationCard);
//Vue.use(VueIziToast);
Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  }
});
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
new Vue({
  router,
  store,
  provide() {
    return {
      eventBus: new Vue()
    };
  },
  render: h => h(App),
  created() {
    AOS.init({ startEvent: "load" });

    window.addEventListener("load", function() {
      AOS.refresh();
    });
  },

  beforeDestroy() {
    window.removeEventListener("load", function() {
      AOS.refresh();
    });
  }
}).$mount("#app");
